module.exports = __webpack_public_path__ + "img/4dd9445.png";